import { render, staticRenderFns } from "./field-boolean.vue?vue&type=template&id=198e6be5"
import script from "./field-boolean.vue?vue&type=script&lang=js"
export * from "./field-boolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports